import React from "react";
import FishingTodayCard from "../components/FishingTodayCard";
import "../styles/pages/FishingToday.css";

export default function FishingToday({
  favoriteSpotOutlookContext = null,
  onLeaveFavoriteSpot,
  onOpenProfile,
  onOpenBioEditor,
}) {
  return (
    <main className="fishing-today-page">
      <div className="fishing-today-page__content">
        <FishingTodayCard
          favoriteSpotOutlookContext={favoriteSpotOutlookContext}
          onLeaveFavoriteSpot={onLeaveFavoriteSpot}
          onOpenProfile={onOpenProfile}
          onOpenBioEditor={onOpenBioEditor}
        />
      </div>
    </main>
  );
}
